module.exports = __webpack_public_path__ + "img/card-generic.b3ecc555.svg";